import React from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import { ITableProps } from '../../../Table/models/index.js';
import { ITableRow } from '../../../Table/models/ITableRow.js';
import Table from '../../../Table/Table.js';
import { ITableGrouping } from '../../models/ITableGrouping.js';
import { ITableGroupingGroup } from '../../models/ITableGroupingGroup.js';
import Groups from '../Groups/Groups.js';

import { IGroupBodyConfiguration, IGroupBodyProps, IGroupBodyState } from './models/index.js';
import {
	GROUP_BODY_CATEGORY_KEY,
	GROUP_BODY_COMPONENT_KEY,
	GROUP_BODY_PARENT_COMPONENT_KEY,
} from './GroupBody.meta.js';

export class GroupBody extends ComponentBase<IGroupBodyProps, IGroupBodyState, IGroupBodyConfiguration> {
	categoryKey = GROUP_BODY_CATEGORY_KEY;
	componentKey = GROUP_BODY_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return GROUP_BODY_PARENT_COMPONENT_KEY;
	}

	constructor(props: IGroupBodyProps) {
		super(props);

		makeObservable(this, {
			grouping: computed,
			tableProps: computed,
			childGrouping: computed,
			group: computed,
			childGroups: computed,
		});
	}

	get grouping(): ITableGrouping {
		return this.props.grouping;
	}

	get tableProps(): ITableProps {
		return {
			...this.grouping.tableProps,
			rows: [...this.rows],
		};
	}

	get childGrouping(): ITableGrouping | undefined {
		return this.grouping.childGrouping;
	}

	get rows(): ITableRow[] {
		const { rows = [] } = this.props;
		return rows;
	}

	get group(): ITableGroupingGroup | undefined {
		return this.props.group;
	}

	get childGroups(): ITableGroupingGroup[] {
		return (this.group && this.group.children) || [];
	}

	render() {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { children, grouping, rows, assignRef, configuration, group, ...otherProps } = this.props;
		const tableProps = this.tableProps;
		return (
			<section {...otherProps}>
				{this.childGrouping && (
					<Groups
						grouping={this.childGrouping}
						parentGrouping={this.grouping}
						groups={this.childGroups}
						rows={this.rows}
					/>
				)}
				{!this.childGrouping && <Table {...tableProps} rows={this.rows} />}
			</section>
		);
	}
}

export default InjectedStyledComponent(observer(GroupBody), GROUP_BODY_CATEGORY_KEY, GROUP_BODY_PARENT_COMPONENT_KEY, [
	GROUP_BODY_COMPONENT_KEY,
]);
